import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFromMonth',
    standalone: false
})
export class DateFromMonthPipe implements PipeTransform {

  transform(firstCalendarDate: Date, numberOfMonth: number): Date {
    const month = firstCalendarDate.getMonth() + numberOfMonth;
    if (month < 12) {
      const currentDate = new Date(firstCalendarDate.getFullYear(), month, 1);
      return currentDate;
    }

    const nextYearMonth = month - 12
    const current = new Date(firstCalendarDate.getFullYear() + 1, nextYearMonth, 1);
    return current;
  }

}
